import { render } from "./CreditsTrackerPage.vue?vue&type=template&id=37af5a22&scoped=true"
import script from "./CreditsTrackerPage.vue?vue&type=script&lang=js"
export * from "./CreditsTrackerPage.vue?vue&type=script&lang=js"

import "./CreditsTrackerPage.vue?vue&type=style&index=0&id=37af5a22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37af5a22"]])

export default __exports__